import { AXNUIContent } from "@iddataweb/idw-common-ui/types";
import { AttributeLabel, AttributeType } from "@idw-types/data/reference-data/generic";
import { sortNumbers } from "./number-util";

export const getDefaultAttributeLabel = (
    attributeType: AttributeType,
    attributeLabels: Array<AttributeLabel>,
    axnuiContent: AXNUIContent
): AttributeLabel => {
    let attributeLabel: AttributeLabel = null;

    if (attributeLabels.length > 0) {
        // look in the default axnui content to find what we consider to be the default label
        // if we find an attribute label that matches this text, set it as the default selected label
        // ^^ this should always find a label
        const defaultLabel = axnuiContent?.labels?.attributes[attributeType?.name];
        const defaultAttributeLabel = attributeLabels.find(al => al.label === defaultLabel);
        if (defaultAttributeLabel) {
            attributeLabel = defaultAttributeLabel
        }
        //otherwise - grab the label with the lowest ID
        else {
            const sortedAttributeLabels = [...attributeLabels].sort((a, b) => sortNumbers(parseInt(a.id), parseInt(b.id)));
            attributeLabel = sortedAttributeLabels[0];
        }
    }

    return attributeLabel;
};